module.exports = __webpack_public_path__ + "static/media/bbq-text-2.255f9988.jpg";